/**
 * Utility function for retrieving the navigation performance entry. There are two levels of the Navigation Timing API we need to handle.
 * Use the level 2, if not available, fallback. If none is available, return false so we can short circuit there.
 */
// @TODO: As the calculations change between the level 1 and level 2, we may tweak the entry right here to standardize what we use on a future release.
export function getNavEntry() {
    if (!window.performance)
        return false; // We're in a dark place.
    return performance.getEntriesByType ? // If no entries we'll get undefined.
        performance.getEntriesByType('navigation')[0] : // lvl2
        performance.timing; // lvl1.
}
